import { type AxiosRequestConfig, type AxiosResponse } from 'axios';

import type ApiDefinition from './ApiDefinition';
import client from './client';

type AxiosKey = string | [string, Omit<AxiosRequestConfig, 'url'>];

export const noodleApiFetcher = <Data>(key: AxiosKey): Promise<AxiosResponse<Data>['data']> => {
  const resolvedConfig: AxiosRequestConfig = Array.isArray(key) ? { url: key[0], ...key[1] } : { url: key };
  return client.request(resolvedConfig).then((res) => res.data);
};

export type { ApiDefinition, AxiosKey };
export default client;
